// src/components/Cases.jsx
import React from 'react';
import '../css/Cases.css';

import goodmask from '../assets/cases/goodmask.png';
import rabbitmoney from '../assets/cases/rabbitmoney.png';
import goodmoment from '../assets/cases/goodmoment.png';
import upright from '../assets/cases/upright.png';

const cases = [
  {
    title: 'Good Mask App',
    description: 'An e-commerce app with a member system integrated with an onsite POS system.',
    image: goodmask,
  },
  {
    title: 'RabbitMoney Web System',
    description: 'A loan company platform featuring a member system and eKYC functions.',
    image: rabbitmoney,
  },
  {
    title: 'Good Moment',
    description: 'A photo studio enhanced by an interactive AR photo solution.',
    image: goodmoment,
  },
  {
    title: 'Upright Learning',
    description: 'A learning center offering STEAM + AI solutions for kids and tutors.',
    image: upright,
  },
];

const Cases = () => {
  return (
    <section className="cases" id="cases">
      <div className="cases-container">
        <h2 className="section-title">Successful Cases</h2>
<div className="case-grid">
  {cases.map((item, index) => (
    <div className="case-wrapper" key={index}>
      <h3 className="case-title">{item.title}</h3> {/* Title OUTSIDE box */}
      <div className="case-card">
        <img src={item.image} alt={item.title} className="case-image" />
        <div className="case-info">
          <p>{item.description}</p>
        </div>
      </div>
    </div>
  ))}
</div>
      </div>
    </section>
  );
};

export default Cases;
